window.initAceEditor = ({editorId, mode, value, readonly}) => ({
    editorBlock: null,
    documentValue: null,
    init() {
        this.documentValue = value || this.$refs.source_doc?.value || ''

        const editor = ace.edit(editorId, {
            mode: "ace/mode/" + mode
        });
        this.editorBlock = editor;

        editor.setTheme("ace/theme/chrome");
        editor.session.setValue(this.documentValue);

        const self = this
        editor.session.on('change', function () {
            self.documentValue = editor.session.getValue();
        });

        if (readonly) {
            this.setReadOnly()
        }
    },
    updateDocumentValue(value) {
        this.editorBlock.session.setValue(JSON.stringify(value, '', 2))
    },
    setReadOnly() {
        // this.editorBlock.session.setUseWorker(false);
        // this.editorBlock.setShowPrintMargin(false);
        this.editorBlock.setReadOnly(true);
    }
})
